import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Column,
  Columns,
  Container,
  TextInput,
} from '@resurs/midas-react'
import { Redirect } from 'react-router-dom'

import { getText } from '../../../internal/TextLabels'
import { format } from '../../../models/format'

import Page from '../../../internal/Page'

import 'formdata-polyfill'
import BackToLogin from '../../../internal/BackToLogin'

const ForgotUI = ({ reset, onReset }) => (
  <div>
    {reset && <Redirect to="/" />}
    <Container grid960>
      <Columns>
        <Column col4 colMd2 colSm0 />
        <Column col4 colMd8 colSm12>
          <div style={{ marginTop: '6rem' }}>
            <Page title={getText('password.forgot.title')}>
              <Container>
                <Columns>
                  <Column col12>
                    <div style={{ padding: '1rem' }}>
                      <form
                        onSubmit={e => {
                          e.preventDefault()
                          const data = new FormData(e.target)
                          onReset(data.get('reset-password-email'))
                        }}
                      >
                        <TextInput
                          id="reset-password-email"
                          label={getText('password.forgot.email')}
                          format={format.email}
                          required={getText('default.form.required')}
                          onChange={() => {
                            /* without this function errors will be thrown */
                          }}
                        />
                        <Button
                          id="forgot-password-button"
                          text={getText('password.forgot.reset')}
                          type="primary"
                          fullWidth
                          form
                        />
                      </form>
                    </div>
                  </Column>
                </Columns>
              </Container>
            </Page>
          </div>
          <BackToLogin />
        </Column>
      </Columns>
    </Container>
  </div>
)

ForgotUI.propTypes = {
  reset: PropTypes.bool.isRequired,
  onReset: PropTypes.func.isRequired,
}

export default ForgotUI
